import apiClient from './index';

export type ReplacementNewDevice = {
  serial_number: string;
  dev_eui?: string | null;
  mqtt_topic?: string | null;
  manufacturer?: string | null;
  name?: string | null;
  system_type?: string | null;
  description?: string | null;
  reading_collection_mode?: 'automatic' | 'file_import' | null;
};

export type ReplacementNewHead = {
  serial_number?: string | null;
  dev_eui: string;
  manufacturer?: string | null;
  model?: string | null;
  building_id?: string | null;
  notes?: string | null;
};

export type ReplacementRadiator = {
  catalog_id?: string | null;
  model_name?: string | null;
  manufacturer?: string | null;
  placement?: string | null;
  room_label?: string | null;
  section_count?: number | null;
  power_watts?: number | null;
  height_mm?: number | null;
  width_mm?: number | null;
  depth_mm?: number | null;
  is_corner?: boolean;
  heat_coefficient?: number | null;
  heat_reduction_coefficient?: number | null;
  notes?: string | null;
};

export type DeviceReplacementCreate = {
  replacement_scope?: 'meter' | 'head' | 'radiator' | 'both';
  new_device?: ReplacementNewDevice | null;
  new_radiator?: ReplacementRadiator | null;
  new_head?: ReplacementNewHead | null;
  head_baseline_meter_value?: number | null;
  changed_at?: string | null;
  old_last_value?: number | null;
  new_start_value?: number | null;
  heat_calculation_mode?: 'AREA' | 'NEW_ONLY' | 'SUM_OLD_NEW';
  reason?: string | null;
  comment?: string | null;
};

export type DeviceReplacementRead = {
  id?: string | null;
  apartment_id?: string | null;
  old_device_id?: string | null;
  new_device_id?: string | null;
  old_device_serial?: string | null;
  new_device_serial?: string | null;
  replacement_scope?: 'meter' | 'head' | 'radiator' | 'both';
  changed_at: string;
  old_last_value?: number | null;
  new_start_value?: number | null;
  heat_calculation_mode?: 'AREA' | 'NEW_ONLY' | 'SUM_OLD_NEW';
  reason?: string | null;
  comment?: string | null;
  created_by_user_id?: string | null;
  head_id?: string | null;
  head_dev_eui?: string | null;
  connection_transferred?: boolean;
};

export const deviceReplacementsApi = {
  async listByApartment(apartmentId: string): Promise<DeviceReplacementRead[]> {
    const res = await apiClient.get<DeviceReplacementRead[]>(
      `/device-replacements/apartments/${apartmentId}`
    );
    return res.data;
  },
  async replaceDevice(deviceId: string, payload: DeviceReplacementCreate): Promise<DeviceReplacementRead> {
    const res = await apiClient.post<DeviceReplacementRead>(
      `/device-replacements/devices/${deviceId}/replace`,
      payload
    );
    return res.data;
  },
};
